var $eef33ec9131405b8$exports = {};
$eef33ec9131405b8$exports = {
    "longPressMessage": `Men\xfcy\xfc a\xe7mak i\xe7in uzun bas\u{131}n veya Alt + A\u{15F}a\u{11F}\u{131} Ok tu\u{15F}una bas\u{131}n`
};


export {$eef33ec9131405b8$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
